import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Observable} from "rxjs";
import {LocalizationStrings} from "../../../i18n/i18n-model";

@Component({
    selector: "app-upload-button",
    templateUrl: "./upload-button.component.html",
    standalone: false
})
export class UploadButtonComponent {
  @Input() uploadInProgress$!: Observable<boolean>;

  @Input() codeCheckInProgress$!: Observable<boolean>;

  @Input() measurementCodeExists!: boolean;

  @Output() uploadClick = new EventEmitter<void>();

  @Input() errorMessage: keyof LocalizationStrings | undefined;

  @Input() warningMessage: string | undefined;

  @Input() uploadButtonLabel!: keyof  LocalizationStrings;

}
